import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Employee } from "./employee";

export interface nurseHandoverSetting{
      hoFieldId:string,
    position:number,
    mandatory:'Y'|'N',
    hide:'Y'|'N',
    datatype:string,
    tenantId: string;
    branchId: string;
}

export interface nurseHOMst{
      id?:number 
      regId:string 
      admId:number 
      nurseHODateTime:Date 
      currentNurseId:string 
      receiverNurseId:string 
      tenantId:string 
      branchId:string 
      createdDate:Date 
      createdBy:number 
      createdIP:string 
      updatedDate:Date 
      updatedBy:number 
      updatedIP:string 
      detail:nurseHODet
      currentNurseName?:string
      receiverNurseName?:string
}

export interface nurseHODet{
      id:number 
      nHOMstId:number 
      situation:string 
      background:string 
      assessment:string 
      recommendation:string 
      tenantId:string 
      branchId:string 
}



export abstract class NurseHandOverData {
    abstract get(url: string,queryparms:HttpParams): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}>;
    abstract create(url: string, data: nurseHOMst): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}>;
    abstract update(url: string, data: nurseHOMst,queryparams:HttpParams): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}>;
   
  }